import { EmptyState, LazyLoader, Modal } from '@bp/ui-components';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useTimetableStore } from '../TimetableProvider';

export const CardControlModal = observer(() => {
  const { t } = useTranslation();

  const pinboardStore = useTimetableStore();

  const isOpen = pinboardStore.controlMode.isLoading || pinboardStore.timefoldAnalyzeMode.isLoading;
  const loadingTitle = pinboardStore.timefoldAnalyzeMode.isLoading
    ? t('pinboard.timefoldAnalyze.loadingHint')
    : t('pinboard.control.loadingHint');

  return (
    <Modal
      width='s'
      height='s'
      hideHeader
      isOpen={isOpen}
      onRequestClose={() => {
        pinboardStore.setControlModeLoading(false);
        pinboardStore.setTimefoldAnalyzeModeLoading(false);
      }}
      hideCloseButton
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      parent={document.fullscreenElement ? document.getElementById('timetable-grid') : null}
    >
      <EmptyState title={loadingTitle} icon={<LazyLoader size='xxl' embedded />} iconColor='var(--color-grey-dark)' />
    </Modal>
  );
});
